import ApiManager from '../api/crud-manager';
import utils from '../utils';

class latestPagesOverview {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="LatestPagesOverview"]'),
      ...options
    };
    this.apiManager = new ApiManager();
  }

  init() {
    const { moduleList } = this.config;

    if (!moduleList) {
      return;
    }

    moduleList.forEach(module => {
      const { itemsToShow, parentId } = module.dataset;

      const element = module;

      if (parentId) {
        // set parameters
        const parameters = {};
        parameters.parentid = parentId;
        if (itemsToShow != null && Number(itemsToShow) && !Number.isNaN(itemsToShow)) {
          parameters.items = Number(itemsToShow);
        }
        parameters.template = 'pagesOverview';
        const parameterLink = utils.buildApiParameters(parameters);

        element.classList.add('is-loading');

        const url = `/api/v2/page/withProperties${parameterLink}`;
        this.apiManager
          .get(url, 'text/html')
          .then(html => {
            element.innerHTML = html;
            element.classList.remove('is-loading');
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.error('latest pages overview request failed', error);
            element.classList.remove('is-loading');
            return null;
          });
      }
    });
  }
}

export default latestPagesOverview;
